export default {
    accounting: "Бухгалтерия",
    action_log: "Әрекет ету журналы",
    calendar: "Күнтізбе",
    control: "Басқарма",
    doctors: "Дәрігерлер",
    insurance: "Сақтандыру",
    patients: "Пациенттер",
    reports: "Есептер",
    services: "Қызметтер",
    settings: "Баптаулар",
    users: "Пайдаланушылар",
    warehouse: "Қойма",
}

